import React from 'react';
import './CardImage.css';

// Inline, not a stylesheet rule: CRA's css-loader tries to resolve a root-
// relative url() in CSS as a module and fails the build. An inline style is
// passed through untouched.
const PLACEHOLDER = {
  backgroundImage: 'url(/vehicle-placeholder.svg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

/**
 * A listing-grid image whose placeholder is a background rather than a swapped
 * `src`.
 *
 * scripts/prerender.js blocks image bytes on purpose — it wants the src
 * attributes in the captured HTML without waiting for the pixels. The old
 * `onError={e => { e.target.src = '/vehicle-placeholder.svg' }}` defeated
 * that: the blocked request fired the handler, so the snapshot of
 * /buy-taxi-delhi shipped nine copies of the placeholder and a crawler saw a
 * city page with no real photographs while visitors saw the cars.
 *
 * With the placeholder behind the image there is no error handler and no
 * second element: the real URL is always what the markup says, and a genuinely
 * broken image reveals the placeholder underneath it.
 */
const CardImage = ({ src, alt, className = '' }) => (
  <img
    src={src || '/vehicle-placeholder.svg'}
    alt={alt}
    loading="lazy"
    className={['card-image', className].filter(Boolean).join(' ')}
    style={PLACEHOLDER}
  />
);

export default CardImage;
